export default __webpack_public_path__ + "static/media/Alert.7dcac575.svg";